module.exports = __webpack_public_path__ + "assets/img/coupon.0fec9d8f.svg";